import type {UserAndCashQueryVariables} from '../../graphql/generated/types';
import {ADAPTER_QUERY_KEY_PREFIX} from '../constant';

/**
 * Account 도메인 Query Key 관리
 */
export const ACCOUNT_QUERY_KEY_MAP = {
  /**
   * 사용자 및 캐시 정보 조회
   * Origin: useUserAndCashQuery.getKey
   */
  userAndCash: (variables?: UserAndCashQueryVariables) =>
    variables === undefined
      ? [ADAPTER_QUERY_KEY_PREFIX, 'userAndCash']
      : [ADAPTER_QUERY_KEY_PREFIX, 'userAndCash', variables],
  /**
   * 사용자 정보 조회
   * Origin: useUserAndCashQuery.user field
   */
  user: (variables?: UserAndCashQueryVariables) =>
    variables === undefined
      ? ['userAndCash.user']
      : ['userAndCash.user', variables],
  /**
   * 캐시 정보 조회
   * Origin: useUserAndCashQuery.cash field
   */
  cash: (variables?: UserAndCashQueryVariables) =>
    variables === undefined
      ? ['userAndCash.cash']
      : ['userAndCash.cash', variables],
} as const;
